/*
 * ArtMindr — Preview Flow backend connector.
 * variants key = product + '|' + themeSlug + '|' + cover (coloring: soft/hard, poster: classic/premium, reading: single)
 */
(function(){
  'use strict';
  var AMF = window.AMFConfig = {
    enabled: true,
    previewUrl: 'https://preview.artmindr.com/api/preview',
    variants: {
      'coloring|fairy|soft':54357077000534,'coloring|fairy|hard':54357077033302,
      'coloring|princess|soft':54357150728534,'coloring|princess|hard':54357150761302,
      'coloring|ice_princess|soft':54357150859606,'coloring|ice_princess|hard':54357150892374,
      'coloring|ballet|soft':54357150925142,'coloring|ballet|hard':54357150957910,
      'coloring|superhero|soft':54357151678806,'coloring|superhero|hard':54357151711574,
      'coloring|dinosaurs|soft':54357151809878,'coloring|dinosaurs|hard':54357151842646,
      'coloring|football|soft':54357151875414,'coloring|football|hard':54357151908182,
      'coloring|lost_symbol|soft':54357152661846,'coloring|lost_symbol|hard':54357152694614,
      'coloring|astronaut|soft':54357152891222,'coloring|astronaut|hard':54357152923990,
      'coloring|doctor|soft':54357153055062,'coloring|doctor|hard':54357153087830,
      'coloring|mermaid|soft':54357153382742,'coloring|mermaid|hard':54357153415510,
      'coloring|knight|soft':54357153448278,'coloring|knight|hard':54357153481046,
      'poster|fairy|classic':54357078344022,'poster|fairy|premium':54357078376790,
      'poster|princess|classic':54357157183830,'poster|princess|premium':54357157216598,
      'poster|mermaid|classic':54357158068566,'poster|mermaid|premium':54357158101334,
      'poster|astronaut|classic':54357159018838,'poster|astronaut|premium':54357159051606,
      'poster|superhero|classic':54357159084374,'poster|superhero|premium':54357159117142,
      'poster|ice_princess|classic':54357159248214,'poster|ice_princess|premium':54357159280982,
      'poster|ballet|classic':54357160067414,'poster|ballet|premium':54357160100182,
      'poster|dinosaurs|classic':54357161673046,'poster|dinosaurs|premium':54357161705814,
      'poster|football|classic':54357161804118,'poster|football|premium':54357161836886,
      'reading|fairy|single':54357165048150,'reading|princess|single':54357165441366,'reading|mermaid|single':54357165539670,'reading|astronaut|single':54357165670742,'reading|superhero|single':54357165834582,'reading|vacation|single':54357165867350
    },
    masterBoxVariant: 54357165998422,
    cartProps: function(state){ return { 'Име на детето': state.name, 'Тема': state.themeLabel || state.theme, 'Корица': state.coverLabel || '', 'Преглед': state.photoUrl || '' }; }
  };
  var GENDER = { 'момиче':'girl', 'момче':'boy' };
  if(!AMF.enabled) return;
  window.amfGenerate = function(state){
    if(!state.photoUrl){ console.error('[amf] no photoUrl'); window.amfPreviewReady(''); return; }
    fetch(AMF.previewUrl, { method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ photo_url: state.photoUrl, child_name: state.name, gender: GENDER[state.gender] || 'girl', theme: state.theme || 'fairy', email: state.email, product: state.product || 'reading' }) })
    .then(function(r){ return r.json(); })
    .then(function(d){ window.amfPreviewReady((d && d.preview_url) || ''); })
    .catch(function(e){ console.error('[amf] generate error', e); window.amfPreviewReady(''); });
  };
  function addToCart(variantId, state, qty){
    return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ id: variantId, quantity: qty||1, properties: AMF.cartProps(state) }) })
      .then(function(r){ if(!r.ok){ return r.json().then(function(e){ throw new Error(e && e.description || 'cart'); }); } return r; });
  }
  window.amfOnOrder = function(state){
    var key = state.product + '|' + state.theme + '|' + (state.cover || 'single');
    var vid = AMF.variants[key];
    if(!vid){ alert('Тази комбинация още не е налична.'); return; }
    addToCart(vid, state).then(function(){ window.location.href = '/checkout'; })
      .catch(function(){ alert('Този вариант още не е наличен.'); });
  };
  window.amfOnUpsell = function(state){
    if(!AMF.masterBoxVariant){ return; }
    addToCart(AMF.masterBoxVariant, state).then(function(){ window.location.href = '/checkout'; })
      .catch(function(){ alert('Master Box още не е наличен.'); });
  };
})();
